export { default } from './blog-recent-posts';
export { default as BlogRecentPostsConfig } from './blog-recent-posts.config';
